import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * @typedef Props
 * @prop {React.ReactNode} children
 * @prop {string} [className]
 */
/**
 * @param {Props & {[x: string]: any;}} props
 */
const MotifModalBody = (props) => {
  const { children, className = '', ...other } = props;
  const classes = classNames({
    'motif-modal-body': true,
    [className]: true
  });

  return (
    <div {...other} className={classes} data-motif-modal-body>
      {children}
    </div>
  );
};

MotifModalBody.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

export { MotifModalBody };
